import { useTheme } from 'react-native-paper';
import styled from 'styled-components';

import { DateTimeInputProps } from './date-time-input-props';

export const DateTimeInput = ({
  label,
  name,
  onChange,
  value,
}: DateTimeInputProps) => {
  const { colors } = useTheme();

  const handleChange = ({ target }: React.ChangeEvent<HTMLInputElement>) => {
    onChange(target.value);
  };
  return (
    <Container>
      <Label color={colors.dark3} htmlFor={name}>
        {label}
      </Label>
      <Input
        name={name}
        type="datetime-local"
        borderColor={colors.dark3}
        borderFocusColor={colors.primary}
        onChange={handleChange}
        value={value}
      />
    </Container>
  );
};

const Container = styled.div`
  flex-direction: column;
  display: flex;
`;

interface InputProps {
  borderColor: string;
  borderFocusColor: string;
}
const Input = styled.input<InputProps>`
  font-family: Poppins-Regular;
  padding: 20px;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  border-color: ${({ borderColor }) => borderColor};
  &:focus {
    border-color: red;
    box-shadow: 0px 0px 0px red;
  }
`;

interface LabelProps {
  color: string;
}
const Label = styled.label<LabelProps>`
  color: ${({ color }) => color};
  margin-bottom: 4px;
  font-family: Poppins-Regular;
`;
